__turbopack_context__.v({
  "cornerstoneNavigation": "CornerstoneNavigation-module-scss-module__r8tb3W__cornerstoneNavigation",
});
